var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"shom",attrs:{"src":`/data/shom/${_vm.port}.html`},on:{"load":function($event){return _vm.resizeHeight($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }